/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { BankAccount } from '../model/bankAccount';
import { BankAccountAssignRequest } from '../model/bankAccountAssignRequest';
import { EditBankAccount } from '../model/editBankAccount';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class SavedBankAccountApiService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public achFeatureObservable: any = undefined;

    /**
     * Check if saved payments feature for ach is enabled
     * 
          */
    @action
    public achFeature(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<any>(
            `${this.basePath}/api/bankaccounts/feature/ach`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.achFeatureObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public assignBankAccountObservable: BankAccount | undefined = undefined;

    /**
     * Assign BankAccount as Primary and/or to all memberships.
     * 
     * @param customerId 
* @param bankAccountId 
* @param body 
     */
    @action
    public assignBankAccount(customerId: number, bankAccountId: number, body?: BankAccountAssignRequest, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<BankAccount> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling assignBankAccount.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling assignBankAccount.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.put<BankAccount>(
            `${this.basePath}/api/bankaccounts/${encodeURIComponent(String(customerId))}/${encodeURIComponent(String(bankAccountId))}/assignments`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.assignBankAccountObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public deleteBankAccountObservable: any = undefined;

    /**
     * Deletes bank account from user account with provided id.
     * 
     * @param customerId 
* @param bankAccountId 
     */
    @action
    public deleteBankAccount(customerId: number, bankAccountId: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling deleteBankAccount.');
        }
        if (bankAccountId === null || bankAccountId === undefined) {
            throw new Error('Required parameter bankAccountId was null or undefined when calling deleteBankAccount.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.delete<any>(
            `${this.basePath}/api/bankaccounts/${encodeURIComponent(String(customerId))}/${encodeURIComponent(String(bankAccountId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.deleteBankAccountObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public payByBankFeatureObservable: any = undefined;

    /**
     * Check if saved payments feature for ach is enabled
     * 
          */
    @action
    public payByBankFeature(showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<any>(
            `${this.basePath}/api/bankaccounts/feature/paybybank`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.payByBankFeatureObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public saveBankAccountObservable: BankAccount | undefined = undefined;

    /**
     * Save/Edit bank account.
     * 
     * @param customerId 
* @param body 
     */
    @action
    public saveBankAccount(customerId: number, body?: EditBankAccount, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<BankAccount> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling saveBankAccount.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<BankAccount>(
            `${this.basePath}/api/bankaccounts/${encodeURIComponent(String(customerId))}`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.saveBankAccountObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public savedBankAccountsObservable: Array<BankAccount> | undefined = undefined;

    /**
     * Retrieves all saved bank accounts for logged-in user
     * 
     * @param customerId 
     */
    @action
    public savedBankAccounts(customerId: number, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<BankAccount>> {
        if (customerId === null || customerId === undefined) {
            throw new Error('Required parameter customerId was null or undefined when calling savedBankAccounts.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<BankAccount>>(
            `${this.basePath}/api/bankaccounts/${encodeURIComponent(String(customerId))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.savedBankAccountsObservable = response.data);
            }
            return response;
        });
    }

}
